import Vue from 'vue';
import Vuex from 'vuex';
import {getField, updateField} from 'vuex-map-fields';

Vue.use(Vuex);

const getDefaultState = () => {
    return {
        loading              : false,
        isCheckout           : false,
        reference            : window.reference ? window.reference : '',
        paymentMethods       : window.paymentMethods ? window.paymentMethods : {},
        selectedPaymentMethod: window.selectedPaymentMethod ? window.selectedPaymentMethod : '',
        total                : window.total ? window.total : 0,
        client_secret        : window.clientSecret ? window.clientSecret : '',
        invoices             : window.invoices ? window.invoices : [],
        currency             : window.currency ? window.currency : {},
        errors               : {},
        payment              : window.payment ? window.payment : {},
        paymentStatus        : window.paymentStatus ? parseInt(window.paymentStatus) : null,
        hasValidationErrors  : false,
        bank                 : window.bank ? window.bank : null,
        payButtonLabel: null,
    }
};

const state = getDefaultState();

export const store = new Vuex.Store({
    state,
    getters  : {
        getField,
        isSingleInvoice(state) {
            return state.invoices.length === 1;
        }
    },
    mutations: {
        updateField
    },
    actions: {

    }
});
